module.exports = __webpack_public_path__ + "img/Lsg_Frequenz2.4a1636a0.jpg";